import React from "react";
import "./Yellow_BG_Btn.css";

const Yellow_BG_Btn = ({
    text = "Click Me",
    onClick,
    type = "button",
    className = "",
    disabled = false
}) => {
    return (
        <div className="yellow_btn_holder">
            <button
                disabled={disabled}
                type={type}
                className={`yellow_bg_btn ${className}`}
                onClick={onClick}
            >
                {text}
            </button>
        </div>

    );
};

export default Yellow_BG_Btn;
